export default __webpack_public_path__ + "bc6d6bc27af191fc8b7a511d2d05d497.svg";